import { withErrorBoundary } from "@sentry/nextjs";
import { FC } from "react";
import styled from "styled-components";
import { Markdown } from "components";

interface Props {
  content: {
    pricing5Title: string;
    pricing5Description?: string;
  };
}

const Pricing5TopSection: FC<Props> = withErrorBoundary(({ content: { pricing5Title, pricing5Description } }) => {
  return (
    <StyledPricing5Top>
      <Markdown className="Pricing5Top__title Font_48_54_600 lg:Font_40_48_600">{pricing5Title}</Markdown>

      {pricing5Description && (
        <Markdown className="Pricing5Top__description Font_18_26_450 Color_secondary">{pricing5Description}</Markdown>
      )}
    </StyledPricing5Top>
  );
}, {});

const StyledPricing5Top = styled.div`
  width: 650px;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 0 auto;

  .Pricing5Top__title {
    margin-top: 16px;
  }

  .Pricing5Top__description {
    margin-top: 24px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    width: 600px;

    .Pricing5Top__description {
      margin-top: 16px;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: unset;
    text-align: left;
    padding: 0 24px;
  }
`;

export { Pricing5TopSection };
